import { Component } from "react";
import Select from "react-select";
import { DeleteKeys, updateCardStyle } from "../../../../../actions/appsMoreAction";
import { TOAST_DISMISS, TOAST_ERROR, TOAST_SUCCESS } from "../../../../../utils";
import CheckBoxField from "../../Feeds/AddFeeds/Elements/CheckboxField";
import InputSlider from "../../Feeds/AddFeeds/Elements/InputSlider";
import { Accordion } from "react-bootstrap";
import ColorPicker from "../../../../CommonComponents/ColorPicker";
class CardStyle extends Component {

  constructor(props) {
    super(props);
    const { wallData } = props;
    const Personalization = wallData.wall.Personalization;

    this.state = {
      fontStyleSelect: [],
      fontStyleSelectAuthor: [],
      fontDefault: 0,
      authourfontDefault: 0,
      fontVarSelect: [],
      fontVarSelectAuthor: [],
      socialIconColorSelect: [
        { label: "Default Colors", value: 505 },
        { label: "Choose Colors", value: 1 },
      ],
      cardColorStatus: [
        { label: "Default Colors", value: 505 },
        { label: "Choose Colors", value: 1 },
      ],
      captionPosition: [
        { label: "Bottom", value: 0 },
        { label: "Top", value: 1 },
      ],
      fontWeight: [
        { label: "Default", value: 0 },
        { label: "Normal", value: 1 },
        { label: "Semi-Bold", value: 2 },
        { label: "Bold", value: 3 },
      ],

      displayTheme: Personalization.displayTheme,
      wallId: Personalization.wallId,
      themeId: Personalization.ThemeRule.themeId,
      themeRuleId: Personalization.ThemeRule.id,
      personalizationId: Personalization.id,
      ownerId: localStorage.getItem('ownerId'),
      spinner: false,
      fontVDefault: 0,
      fontVDefaultAuthor: 0,
      CTAUpgrade: false,
    };
  }


  componentDidMount() {
    let {   fontDefault,authourfontDefault, fontVDefault,fontVDefaultAuthor } = this.state;
    const { link_font, css_font, font_varient, authorFont  } = this.props.cardStyle
    const { fonts } = this.props

    let fontStyleSelectData = [{ label: `Default`, value: 0 }];
    fonts && fonts.length && fonts.map((font, index) => {

      if (String(font.family).toLowerCase() == String(css_font).toLowerCase()) {
        fontDefault = parseInt(index) + 1
      }

      if (String(font.family).toLowerCase() == String(authorFont).toLowerCase()) {
        authourfontDefault = parseInt(index) + 1
      }

      fontStyleSelectData.push({
        label: (
          <span key={font.family} style={{ fontFamily: `${font.family}` }} className={`sGFfonte-${font}`} >
            {font.family}
          </span>), value: font.id
      })
    })
    const f = fonts && fonts.length && fonts.filter((font) => String(font.family).toLowerCase() == String(css_font).toLowerCase())[0]

    let selectedData = null;
    if (link_font && f && Object.keys(f).length > 0) {
      selectedData = JSON.parse(f.variants).map((f, i) => {
        if (String(f).toLowerCase() == String(font_varient).toLowerCase()) {
          fontVDefault = i
        }
        return ({
          'label': (<span key={f} style={{ fontFamily: `${css_font}` }} className={`sGFfonte-${f}`} >
            {f}
          </span>), 'value': i
        })
      })
    }
    else {
      selectedData = [{ 'label': 'None', 'value': 0 }]
    }


    let selectedDataAuthor = null;
    if (link_font && f && Object.keys(f).length > 0) {
      selectedDataAuthor = JSON.parse(f.variants).map((f, i) => {
        if (String(f).toLowerCase() == String(font_varient).toLowerCase()) {
          fontVDefaultAuthor = i
        }
        return ({
          'label': (<span key={f} style={{ fontFamily: `${css_font}` }} className={`sGFfonte-${f}`} >
            {f}
          </span>), 'value': i
        })
      })
    }
    else {
      selectedDataAuthor = [{ 'label': 'None', 'value': 0 }]
    }

    this.setState({ fontStyleSelect: fontStyleSelectData, fontStyleSelectAuthor: fontStyleSelectData, fontDefault, authourfontDefault, fontVarSelect: selectedData, fontVDefault, fontVDefaultAuthor })
  }



  onBtnFontChange = (e) => {

    const { fonts,themecardStyle } = this.props
    this.setState({ fontVarSelect: [] })

    try {
      const channel = new BroadcastChannel('connect');
      channel.postMessage(JSON.stringify({ networkId: e, type: 'editor-theme' }));
    } catch (error) {
      window.close();
    }

    const f = fonts.filter((font) => font.id === e.value)[0]
    var selectedData = null;
    if (e.value) {
      selectedData = JSON.parse(f.variants).map((f, i) => {
        return ({
          'label': (<span key={f} style={{ fontFamily: `${e.label.key}` }} id='fontVar-subtitle' className={`sGFfonte-${f}`}>
            {f}
          </span>), 'value': i
        })
      })
    }
    else {
      selectedData = [{ 'label': 'None', 'value': 0 }]
    }

     this.setState({ fontVarSelect: selectedData, fontVDefault: 0 })
     themecardStyle({ link_font: e.label.key, css_font: e.label.key, font_varient: selectedData[0].label.key })
  }


  onAuthorFontChange = (e) => {

    const { fonts,themecardStyle } = this.props
    this.setState({ fontVarSelectAuthor: [] })

    const f = fonts.filter((font) => font.id === e.value)[0]
    var selectedData = null;
    if (e.value) {
      selectedData = JSON.parse(f.variants).map((f, i) => {
        return ({
          'label': (<span key={f} style={{ fontFamily: `${e.label.key}` }} id='fontVar-subtitle' className={`sGFfonte-${f}`}>
            {f}
          </span>), 'value': i
        })
      })
    }
    else {
      selectedData = [{ 'label': 'None', 'value': 0 }]
    }

    this.setState({ fontVarSelectAuthor: selectedData, fontVDefaultAuthor: 0 })
    themecardStyle({ linkfontAuthor: e.label.key, authorFont: e.label.key, authorFontVariant: e.label.key?  selectedData[0].label.key :  selectedData[0].label })
  }


  onChangeVariant = (e) => {
    this.setState({ fontVDefault: e.value })
    this.props.themecardStyle({ font_varient: e.label.key })
  }

  onAuthourFontVariant = (e) => {
    this.setState({ fontVDefaultAuthor: e.value })
    this.props.themecardStyle({ authorFontVariant: e.label.key })
  }

  onSubmitData = (e) => {
    const { wallId, themeId, personalizationId,themeRuleId } = this.state;
    const { cardStyle, wallData } = this.props;

    const { spacing, borderRadius, captionStatus, captionFontWeight, ctaStatus, shareOption, socialAction, fontSize, cardColor, cardType, fontColor,hideContent, authorColor, iconColor, padding, link_font, iconType, css_font, postTime, postAuthor, font_varient, linkfontAuthor, authorFont, authorFontVariant } = cardStyle

    const data = {
      link_font: !link_font ? '' : link_font.split(' ').join('+'),
      css_font: !css_font ? '' : css_font,
      font_varient: !font_varient ? '' : font_varient,

      linkFontAuthor: !linkfontAuthor ? '' : linkfontAuthor.split(' ').join('+'),
      authorFont: authorFont,
      authorFontVariant: authorFontVariant,
      cardColor: cardType == 505 ? '#ffffff' : `${cardColor}`,
      fontColor: `${fontColor}`,
      fontSize: fontSize,
      authorColor: `${authorColor}`,
      iconType: iconType,
      iconColor: iconType == 1 ? `${iconColor}` : '',
      postTime: postTime,
      postAuthor: postAuthor,
      ctaStatus: Number(ctaStatus),
      shareOption: shareOption,
      socialAction: socialAction,
      hideContent: Number(hideContent),
      themeRuleId: themeRuleId,
      isCollaborator: 0,
      ownerId: localStorage.getItem('ownerId'),
      cardType: cardType,
      captionFontWeight: captionFontWeight,
      spacing: spacing,
      padding: padding,
      borderRadius: borderRadius,
      captionStatus: captionStatus,
      themeId: themeId
    }

  

    if (e) {
      this.setState({ spinner: true })
      updateCardStyle({ data, wallId: wallId, themeId: themeId, personalizationId: personalizationId }).then(res => {
        const { data } = res;
        this.setState({ spinner: false },()=>this.props.activeSetting(0));
        if (data.responseCode == 200) {
          DeleteKeys();
          TOAST_DISMISS();
          TOAST_SUCCESS(data.responseData);
        } else {
          TOAST_DISMISS()
          TOAST_ERROR(data.responseData);
        }
      }).catch((error) => console.warn(error))
    }
  }

  applyChanges = (e,status) => {
    const { showDiscardPop } = this.props;
    showDiscardPop(()=>this.onSubmitData(e), 'card-style',status);
  }

  render() {
    const { fontStyleSelect, fontVarSelect, socialIconColorSelect, fontDefault, fontVDefault, cardColorStatus, fontWeight, authorFontVariant, fontVarSelectAuthor, fontVDefaultAuthor, fontStyleSelectAuthor, authourfontDefault } = this.state;
    const {cardStyle, getThemeSetting, themecardStyle, themeSetting } = this.props;
    
    const { spacing, borderRadius, cardType, themeId, captionFontWeight, fontSize, cardColor, fontColor, hideContent, authorColor, iconColor, socialAction, iconType, padding, postTime, postAuthor } = cardStyle

    return (
      <div className="">
        <div className="overflow-list">
        <div className="pb-3">
          <label className="card-label font-weight-bolder text-dark">Card Style</label>
        </div>
          <Accordion defaultActiveKey="0">

         { (![74].includes(themeId)) ?  
            
            <Accordion.Item eventKey="0">
              
             { (![65,69,73,67,68,71].includes(themeId)) ?  
          
             <Accordion.Header>Background</Accordion.Header> : <Accordion.Header>Setting</Accordion.Header> }
              <Accordion.Body>

                { (![65,69,73,67,68,71].includes(themeId)) ?  <>

                  <div className="">
                    <div className="form-group">
                      <label className="control-label mb-2">Choose Color </label>
                      <Select defaultValue={cardColorStatus[cardType == 505 ? 0 : 1]} options={cardColorStatus}
                        onChange={(e)=> { themecardStyle({ cardType: e.value, cardColor: e.value== 505 ? '#ffffff' : cardColor }) }} />
                    </div>
                  </div>
                  
                  <div className="col-12" style={{ display: cardType == 1 ? '' : 'none' }}>
                    <div className="form-group color-popup position-relative">
                      <label className="control-label mb-2">Card Color</label>
                      <ColorPicker id='cardColor' defaultColor={cardColor} changeColor={(clr) => themecardStyle({ cardColor: clr })} />
                    </div>
                  </div>  

                 </> 
                  :
                 <></>
                }

            { (![64, 69, 68,65, 67, 75, 76, 77,73,78,71].includes(themeId)) ? 
                <div className="form-group">
                  <div className="align-items-center">
                    <div className="col-12"> <label className="d-flex justify-content-between" htmlFor="wallgetPersonalizefontSize" style={{ marginBottom: "0px" }}> Padding  <span><span className="datawallgetPersonalizefontSize" id="value-span">{spacing}</span>px</span> </label>
                      <div className="pt-1 pe-3">
                        <InputSlider onChangeHandler={(event) => themecardStyle({ 'spacing': parseInt(event) })} isValue={spacing} max={30} min={0} />
                      </div>
                    </div>
                  </div>
                </div>:null }


              { (![74,76,77,72].includes(themeId)) ?  
                <div className="form-group">
                  <div className="align-items-center">
                    <div className="col-12"> <label className="d-flex justify-content-between" htmlFor="wallgetPersonalizefontSize" style={{ marginBottom: "0px" }}> Spacing <span><span className="datawallgetPersonalizefontSize" id="value-span">{padding}</span>px</span> </label>
                      <div className="pt-1 pe-3">
                        <InputSlider onChangeHandler={(event) => 
                          themecardStyle({ padding: parseInt(event) })} isValue={padding} max={30} min={0} />
                      </div>
                    </div>
                  </div>
                </div> : null
              }


            { (![74,76,77,68,71,72,73].includes(themeId)) ?  

                <div className="form-group">
                  <div className="align-items-center">
                    <div className="col-12"> <label className="d-flex justify-content-between" htmlFor="wallgetPersonalizefontSize" style={{ marginBottom: "0px" }}>   Border Radius <span><span className="datawallgetPersonalizefontSize" id="value-span">{borderRadius}</span>px</span> </label>
                      <div className="pt-1 pe-3">
                        <InputSlider onChangeHandler={(event) => themecardStyle({ borderRadius: parseInt(event) })} isValue={borderRadius} max={30} min={0} />
                      </div>
                    </div>
                  </div>
                </div> : null }

              </Accordion.Body>
            </Accordion.Item>
            : null }


        { (![67,71,73].includes(themeId)) ?     

           <>
           {(![63,65,69].includes(themeId)) ? 
            <Accordion.Item eventKey="1">
              <Accordion.Header>Caption</Accordion.Header>
              <Accordion.Body>

                <div className="form-group">
                  <div className="d-flex align-items-center">
                    <div className="col-9"> <label className="control-label">Hide/Show</label> </div>
                    <div className="col-3 toggleOnBut justify-content-end"> <span className="switch float-end"> 
                      <CheckBoxField isChecked={!hideContent} onChangeHandler={(e) => themecardStyle({ hideContent: !e.target.checked })} name={`captionStatus`} id={`captionStatus`} text={0} />
                    </span>
                    </div>
                  </div>
                </div>

                { !hideContent ? <>

                 <div className="form-group">
                  <label className="control-label mb-2">Font Family</label>
                  <div className="font-style mb-3">
                    {fontStyleSelect.length ? <Select options={fontStyleSelect} defaultValue={fontStyleSelect[fontDefault]} onChange={(e) => { this.onBtnFontChange(e) }} /> : null}
                  </div>
                  <div className="">
                    {fontStyleSelect.length ? <Select id="fontVDefault" options={fontVarSelect} defaultValue={fontVarSelect[fontVDefault]} value={fontVarSelect[fontVDefault]} onChange={(e) => { this.onChangeVariant(e) }} /> : null} </div>
                </div> 

                {/* <div className="form-group">
                  <label className="control-label mb-2">Font Weight</label>
                  <div className="font-style mb-3">
                    <Select options={fontWeight} onChange={(e) => themecardStyle({ captionFontWeight: e.value })} defaultValue={fontWeight[captionFontWeight]} />
                  </div>
                </div>  */}

                  {
                    (![74, 76, 77, 77, 68].includes(themeId)) ?
                    <div className="form-group">
                      <div className="align-items-center">
                        <div className="col-12"> <label className="d-flex justify-content-between" htmlFor="wallgetPersonalizefontSize" style={{ marginBottom: "0px" }}> Font Size <span><span className="datawallgetPersonalizefontSize" id="value-span">{fontSize}</span>px</span> </label>
                          <div className="pt-1 pe-3">
                            <InputSlider onChangeHandler={(event) => themecardStyle({ fontSize: parseInt(event) })} isValue={fontSize} max={30} min={10} />
                          </div>
                        </div>
                      </div>
                    </div> : null
                  }

             
                <div className="">
                  <div className="form-group color-popup position-relative">                    
                    <label className="control-label mb-2">Font Color</label>
                    <ColorPicker id='fontColor' defaultColor={fontColor} changeColor={(clr) => themecardStyle({ fontColor: clr })} />
                  </div>
                </div>

                </> : null }

              </Accordion.Body>
            </Accordion.Item> : <></>}


            <Accordion.Item eventKey="2">
              <Accordion.Header>Author Details</Accordion.Header>
              <Accordion.Body>

                <div className="ctaAuthorOption">
                  <div className="form-group">
                    <div className="d-flex align-items-center">
                      <div className="col-9"> <label className="control-label">Hide/Show Time</label> </div>
                      <div className="col-3 toggleOnBut justify-content-end"> <span className="switch float-end"> <CheckBoxField isChecked={postTime} onChangeHandler={(e) => themecardStyle({ postTime: e.target.checked ? 1 : 0})} name={`wallThemeRulepostTime`} id={`wallThemeRulepostTime`} text={0} />
                      </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="d-flex align-items-center form-group">
                      <div className="col-9"> <label className="control-label">Hide/Show Author Detail</label> </div>
                      <div className="col-3 toggleOnBut justify-content-end"> <span className="switch float-end"> <label htmlFor="wallThemeRulepostAuthor"> <input type="hidden" name="data[Personalization][postAuthor]" id="wallThemeRulepostAuthor_" /> 
                      <CheckBoxField isChecked={postAuthor} onChangeHandler={(e) => themecardStyle({ postAuthor: e.target.checked ? 1 : 0 })} name={`wallThemeRulepostAuthor`} id={`wallThemeRulepostAuthor`} text={0} />  </label> </span> </div>
                    </div>
                  </div>

                   <div className="form-group">
                    <div className="d-flex align-items-center">
                      <div className="col-9"> <label className="control-label">Hide/Show Social Icon</label> </div>
                      <div className="col-3 toggleOnBut justify-content-end"> <span className="switch float-end"> <label htmlFor="wallhideContent">
                        <CheckBoxField isChecked={socialAction} onChangeHandler={(e) => themecardStyle({ socialAction: e.target.checked ? 1 : 0})} name={`socialAction`} id={`socialAction`} text={0} /> </label> </span> </div>
                    </div>
                  </div>  
                </div>  

                  {
                    postAuthor ?<>
                      <div className="form-group">
                          <label className="control-label mb-2">Font Family</label>
                          <div className="font-style mb-3">
                            {fontStyleSelectAuthor.length ? <Select options={fontStyleSelect} defaultValue={fontStyleSelectAuthor[authourfontDefault]} onChange={(e) => { this.onAuthorFontChange(e) }} /> : null}
                          </div>
                          <div className="">
                            {fontStyleSelectAuthor.length ? <Select id="fontVDefaultAuthor" options={fontVarSelectAuthor} defaultValue={fontVarSelectAuthor[fontVDefaultAuthor]} value={fontVarSelectAuthor[fontVDefaultAuthor]} onChange={(e) => { this.onAuthourFontVariant(e) }} /> : null} </div>
                        </div> 


                      { (![65,69].includes(themeId)) ?
                        <div className="mt-3">
                          <div className="form-group color-popup position-relative">
                            <label className="control-label mb-2">Text Color</label>
                            <ColorPicker id='textColor' defaultColor={authorColor} changeColor={(clr) => themecardStyle({ authorColor: clr })} />
                          </div>
                        </div> : null }
                      
                      </>  :null
                  }        

                {
                  socialAction ?
                     <>
                      <div className="">
                        <div className="form-group color-popup position-relative">
                          <div className="control-label mb-2"> <label className="control-label mb-2"> Social Icon { themeId==78 ? 'Background' : 'Color'}  </label> </div>
                          <div className="font-style mb-3">
                            <Select defaultValue={socialIconColorSelect[iconType == 505 ? 0 : 1]} options={socialIconColorSelect} onChange={e => themecardStyle({ iconType : e.value })} />
                          </div>
                        </div>
                      </div>
                    
                    <div className="form-group" id="iconColorOption" style={{ display: iconType == 1 ? '' : 'none' }}>
                      <div className="color-popup position-relative"> <label className="control-label">{ themeId==78 ? 'Background' : 'Icon'} Color</label>
                        <ColorPicker id='iconColor' defaultColor={iconColor} changeColor={(clr) => themecardStyle({ iconColor: clr })} />
                      </div>
                    </div>  
                 </>  
                : null 
              }

              </Accordion.Body>
            </Accordion.Item>
           </> 

            : <></> }

         </Accordion>

        </div>

        <div className="form-actions px-3 pt-3">
          <div className="card-toolbar f-center">
            <button onClick={(e) => this.applyChanges(e,0)} type="button" className="btn btn-secondary w-100 me-2 position-relative">
              <span className="position-relative">Back</span>
            </button>
            <button type="submit" disabled={this.state.spinner} className={`commanBtn btn-md btn btn-dark w-100 ${this.state.spinner ? `spinner spinner-white spinner-right disabled` : null}`} onClick={(e) => this.applyChanges(e,1)}> Save </button>
          </div>
        </div>
      </div>

    );
  }
}

export default CardStyle